import { render, staticRenderFns } from "./ProjectRevenue.vue?vue&type=template&id=95e6324c&scoped=true&"
import script from "./ProjectRevenue.vue?vue&type=script&lang=js&"
export * from "./ProjectRevenue.vue?vue&type=script&lang=js&"
import style0 from "./ProjectRevenue.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ProjectRevenue.vue?vue&type=style&index=1&id=95e6324c&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e6324c",
  null
  
)

export default component.exports